import React from 'react'
import CarouselSlide from '../Components/CarouselSlide'
import HomeBody from '../Components/HomeBody'
import HomeComponents from '../Components/HomeComponents'

function HomePage() {
  return (
    <div>
      <CarouselSlide />
      <HomeComponents />
      <HomeBody />
      This is kindMeal.my
    </div>
  )
}

export default HomePage
